/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import React, { ChangeEvent } from "react";
import { CellTemplate, Cell, Compatible, Uncertain } from "@silevis/reactgrid";

export interface ImageCell extends Cell {
  type: "image";
  src: string; // URL of the image
  text?: string;
  value?: number;
}

const ImageCellTemplate: CellTemplate<ImageCell> = {
  getCompatibleCell: (cell: Uncertain<ImageCell>): Compatible<ImageCell> => {
    if (cell.type === "image") {
      return { type: "image", src: cell.src ?? "", text: cell.text ?? "", value: cell.value ?? 0 };
    }
    return { type: "image", src: "", text: "", value: 0 };
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleKeyDown: (cell: Compatible<ImageCell>, keyCode: number, ctrl: boolean, shift: boolean, alt: boolean, key?: string, capsLock?: boolean) => {
    // No-op
    return { cell, enableEditMode: false };
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  update: (cell: Compatible<ImageCell>, cellToMerge: Uncertain<ImageCell>): Compatible<ImageCell> => {
    return {
      ...cell,
      type: "image",
      src: cellToMerge.src || cell.src,
    };
  },

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render: (cell: Compatible<ImageCell>, isInEditMode: boolean, onCellChanged: (cell: Compatible<ImageCell>, commit: boolean) => void) => {
    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          onCellChanged({ ...cell, src: reader.result as string }, true);
        };
        reader.readAsDataURL(file);
      }
    };

    return (
      <div>
        {cell.src ? (
          <img src={cell.src} alt="Uploaded" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        ) : (
          <input type="file" onChange={handleFileChange} />
        )}
      </div>
    );
  },
};

export default ImageCellTemplate
